import {
  Message,
  RealTimeService,
} from "./../../service/websockets/realtime.service";
import { FormControl } from "@angular/forms";
import {
  Component,
  OnChanges,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
  HostListener,
} from "@angular/core";
import {
  FormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { Utils } from "src/app/common/utils";
import { AllPatient } from "src/app/models/patient";
import { VproService } from "src/app/service/vpro/vpro.service";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ChatMessages } from "src/app/models/chat-model";
import { Physician } from "src/app/models/physician";
import { SocketsConnectionService } from "src/app/service/websockets/connection.service";
import { WebsocketService } from "src/app/service/websockets/websocket.service";
import { debounceTime } from "rxjs-compat/operator/debounceTime";
import { TypingStatus } from "src/app/models/typing-status";
import { Subscription } from "rxjs";
import { ConnectionService } from "src/app/service/connection/connection.service";

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-patient-chat",
  templateUrl: "./patient-chat.component.html",
  styleUrls: ["./patient-chat.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class PatientChatComponent implements OnInit {
  @ViewChild("PDFModal", { static: true } as any) PDFModal: TemplateRef<any>;
  @ViewChild("callNotification", { static: true } as any)
  callNotification: TemplateRef<any>;
  @ViewChild("chatbox", { static: true } as any) chatbox: TemplateRef<any>;
  @ViewChild("joinChatNotification", { static: true } as any)
  joinChatNotification: TemplateRef<any>;

  public role = Utils.ROLE.PATIENT;
  public homePageUrl = Utils.homePageUrl;
  notificationMessage: string;
  public messageAction = Utils.messageAction;
  public isChatOpen: boolean = true;
  public currentStatus = "";
  public typingStatus: TypingStatus;
  public focus: boolean = false;
  public isMinimize: boolean = false;
  public showOnlineJoinCall: boolean = false;
  public aptid;
  currentDate = Utils.maxDate;
  patient: AllPatient;
  dateFormat = Utils.DATE_FORMAT;
  remainingText: any;
  value: string = " ";
  physcianID: string = "";
  appointment: any;
  isEditable: boolean = true;
  chatUserType = Utils.CHAT_USER_TYPE;
  consultationReport: any;
  pdfSrc: any;
  physicianFee: any;
  public chatForm: UntypedFormGroup;
  messages: ChatMessages[] = [];
  physicianDetail: Physician;
  chatStarted: boolean = false;
  public isOpenSub: Subscription;
  room_id: string = "";
  connection_id: string = "";
  onlineApt: boolean = true;
  audioCall: boolean = false;
  videoCall: boolean = false;
  isOpenSubscribe: Subscription;
  enableCallButton: boolean = false;
  maxSize = Utils.MAX_FILE_VIDEO_SIZE;
  maxFileSize = Utils.MAX_FILE_SIZE;
  modalRef: NgbModalRef;
  joinChatmodalRef: NgbModalRef;
  public sub: Subscription;
  onlineJoinCallRef: NgbModalRef;
  attachmentSignedUrl: string;
  Imagekey: string;
  constructor(
    private wsService: WebsocketService,
    private utils: Utils,
    private modal: NgbModal,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private _formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private realTimeService: RealTimeService,
    private connectionService: ConnectionService,
    private socketsConnectionService: SocketsConnectionService
  ) { }

  async ngOnInit() {
    this.wsService.status.subscribe(async (status) => {
      if (status === "CONNECTED") {
        const Toast = Swal.mixin({
          toast: true,
          position: "top",
          showConfirmButton: false,
        });

        // Toast.fire({
        //   type: "success",
        //   title: "You are now online !",
        //   timer: 2000,
        // });
      }
    });
    this.chatForm = this._formBuilder.group({
      chat_msg: [""],
    });

    let uid = localStorage.getItem("uid");
    if (uid) {
      //if there is any previous connection of patient
      this.isOpenSub = this.wsService.isOpen.distinct().subscribe((value) => {
        if (value === true) {
          this.realTimeService.disconnect();
          localStorage.clear();
          this.getAppointment();
        }
      });
    } else {
      this.getAppointment();
    }

    this.sub = this.service.chatMessageSubject.subscribe((value) => {
      const values: ChatMessages = { ...value };
      if (values.type === Utils.CHAT_ACTION.NEW_MESSAGE) {
        this.messages.push({
          id: values.id,
          body: values.message,
          date: moment().toDate(),
        });
      } else if (values.type === Utils.NOTIFICATION_TYPES.JOIN_CHAT) {
        this.notificationMessage = values.message;
        if (this.joinChatmodalRef) {
          this.closeJoinChatModal();
        }
        this.joinChatmodalRef = this.modal.open(this.joinChatNotification, {
          size: "lg",
          centered: true,
          backdrop: "static",
        });
      } else if (values.type === Utils.NOTIFICATION_TYPES.ENABLE_ONLINE_CALL) {
        // this.showToast("enable","enable audio call")
        this.enableCallButton = true;
        if (this.modalRef) {
          this.closePopUp();
        }
        this.modalRef = this.modal.open(this.callNotification, {
          size: "lg",
          centered: true,
          backdrop: "static",
        });
      } else if (values.type === Utils.CHAT_ACTION.SEND_ATTACHMENT) {
        this.messages.push({
          id: values.id,
          body: {
            previewUrl: values.message.toString(),
            contentType: values.contentType,
            name: values.name,
          },
          date: moment().toDate(),
        });
      } else if (values.type === Utils.NOTIFICATION_TYPES.TYPING_STATUS) {
        this.typingStatus = { status: values.message };
      } else if (values.type === Utils.messageAction.GETMESSAGES) {
        if (values && values.data && values.data.length > 0) {
          this.chatStarted = true;
        }
        values.data.forEach((value) => {
          if (value && value.contentType === "text") {
            this.messages.push({
              id: value.id,
              body: value.body,
              date: value.date,
            });
          } else {
            this.messages.push({
              id: value.id,
              body: {
                previewUrl: value.body.toString(),
                contentType: value.contentType,
                name: value.name,
              },
              date: value.date,
            });
          }
        });
      }
    });
    this.chatForm
      .get("chat_msg")
      .valueChanges.debounceTime(2000)
      .subscribe((value) => {
        let data = { u_id: this.appointment.drid };
        data["id"] = this.appointment.pid;
        data["action"] = this.messageAction.SENDMESSAGE;
        data["room_id"] = this.room_id;
        data["message"] = "";
        // data["message"] = "typing";

        data["type"] = Utils.NOTIFICATION_TYPES.TYPING_STATUS;
        this.currentStatus = "";
        this.realTimeService.send(data);
      });
  }
  @HostListener("window:unload", ["$event"])
  unloadHandler(event) {
    localStorage.clear();
  }

  @HostListener("window:beforeunload", ["$event"])
  beforeunloadHandler(event) {
    event.preventDefault();
    let message =
      "Are you sure you want to leave? Your chat history will not be available";
    event.returnValue = message;
    return event.returnValue;
  }

  getAppointment() {
    this.spinner.show();
    this.aptid = this.route.snapshot.params["aptid"];
    if (this.aptid) {
      this.room_id = this.aptid;
    }
    this.service
      .getAppointmentDetails({
        aptid: this.aptid,
        fields: ["physician_details", "patient_details"],
      })
      .subscribe(
        (res) => {
          if (res) {
            this.spinner.hide();
            this.appointment = res;
            if (this.appointment.drid)
              localStorage.setItem("drid", this.appointment.drid);
            if (this.appointment.pid)
              localStorage.setItem("uid", this.appointment.pid);
            if (this.appointment.apttype) {
              if (
                this.appointment.apttype === Utils.APPOINTMENT_TYPE.AUDIO ||
                this.appointment.apttype === Utils.APPOINTMENT_TYPE.VIDEO
              ) {
                this.onlineApt = true;
              }
              if (this.appointment.apttype === Utils.APPOINTMENT_TYPE.AUDIO) {
                this.audioCall = true;
                this.videoCall = false;
              } else if (
                this.appointment.apttype === Utils.APPOINTMENT_TYPE.VIDEO
              ) {
                this.audioCall = false;
                this.videoCall = true;
              }
              else if (
                this.appointment.apttype === Utils.APPOINTMENT_TYPE.IN_PERSON
              ) {
                this.audioCall = false;
                this.videoCall = true;
              }
            }
            this.getPatient();
            this.getPhysicianDetails();
            this.socketsConnectionService.subscribeToSockets();
            this.isOpenSubscribe = this.wsService.isOpen.subscribe((value) => {
              if (value === true) {
                console.log("websocket is open...");
                this.getChatHistory();
                this.updateRoomId();
              }
            });
          }
        },
        (error) => {
          this.spinner.hide();
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  getPatient() {
    this.spinner.show();
    this.service.getPatientById(localStorage.getItem("uid")).subscribe(
      (res) => {
        this.spinner.hide();
        this.patient = res;
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
      }
    );
  }

  public closeVideoScreen() {
    let video: any = document.querySelector("#preview > video");
    if (video) {
      for (const track of video.srcObject.getTracks()) {
        track.stop();
      }
      video.srcObject = null;
    }
    this.showOnlineJoinCall = false;
    this.isMinimize = false;
  }

  public markMinimize() {
    this.isMinimize = true;
    let element = document.getElementById("cdk");
    element.style.removeProperty("transform");
  }

  async selectFile(event) {
    let data = { u_id: this.appointment.drid };
    data["id"] = this.patient.pid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.CHAT_ACTION.SEND_ATTACHMENT;
    data["aptid"] = this.appointment.aptid;
    data["msg_time"] = moment().utc().format(Utils.DB_TIMESTAMP_FORMAT);
    data["from"] = this.chatUserType.PATIENT;
    let {
      target: { files },
    } = event;
    let [file] = files;
    let reader = new FileReader();
    if (file) {
      let previewUrl;
      if (file.size > this.maxFileSize) {
        this.showToast("error", "File exceeds 2MB");
        event.srcElement.value = null;
        return;
      }
      reader.readAsDataURL(file);
      data["name"] = file.name;
      reader.onload = (event: any) => {
        previewUrl = event.target.result;
        this.messages.push({
          id: this.appointment.pid,
          u_id: this.appointment.drid,
          body: { contentType: file.type, previewUrl, name: file.name },
          date: moment().toDate(),
        });
      };
      //get signed url and upload on S3
      await this.service
        .uploadFile(
          {
            room_id: this.room_id,
            aptid: this.appointment.aptid,
            file: { name: file.name, type: file.type },
          },
          file
        )
        .subscribe(
          (res) => {
            this.attachmentSignedUrl = res.signedUrl;
            this.Imagekey = res.key;
            data["contentType"] = file.type;
            data["message"] = this.Imagekey;
            this.realTimeService.send(data);
            this.spinner.hide();
          },
          (error) => {
            this.spinner.hide();
            this.showToast("error", "Something went wrong.Please try again !");
          }
        );
    }
  }

  sendStatusTyping(event) {
    if (event.keyCode !== 13 && this.currentStatus !== "Typing") {
      this.currentStatus = "Typing";
      //send to websocet
      this.sendStatus();
    }
    //send to websocet
  }

  sendStatus() {
    //sending patient typing status.
    let data = { u_id: this.appointment.drid };
    data["id"] = this.appointment.pid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["message"] = this.currentStatus;
    data["type"] = Utils.NOTIFICATION_TYPES.TYPING_STATUS;
    this.realTimeService.send(data);
  }

  previewImg(i) {
    if (
      Utils.IMGFILE ==
      this.messages[i].body["contentType"].substring(
        0,
        this.messages[i].body["contentType"].indexOf("/")
      )
    ) {
      Swal.fire({
        imageUrl: this.messages[i].body["previewUrl"],
        showConfirmButton: false,
        showCloseButton: true,
      });
    } else {
      this.pdfSrc = this.messages[i].body["previewUrl"];
      this.modal.open(this.PDFModal, {
        size: "lg",
        centered: true,
        backdrop: "static",
      });
    }
  }

  subscribeToChatMessage() {
    this.service.consultNowUpdate.subscribe((data: any) => {
      this.sendJoinChatNotification();
      // this.messages.push({ id: 1118, body: "how are you?", date: moment().toDate() });
      // this.messages.push({ id: 1118, body: "how can I help you?", date: moment().toDate() });
      // //this.messages.push({ id: data.uid, body: data.message, date: moment().toDate() });
    });
  }

  sendJoinChatNotification() {
    let data = { u_id: this.appointment.drid };
    data["id"] = this.appointment.pid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["message"] = "Patient has Joined the ChatRoom";
    data["type"] = Utils.NOTIFICATION_TYPES.JOIN_CHAT;
    this.realTimeService.send(data);
  }

  sendMessage() {
    this.currentStatus = "";
    /* connection id can be retreived at the back-end using u_id (which is pid in this case) */
    let data = { u_id: this.appointment.drid };
    data["id"] = this.appointment.pid;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["room_id"] = this.room_id;
    data["type"] = Utils.CHAT_ACTION.NEW_MESSAGE;
    data["aptid"] = this.appointment.aptid;
    data["msg_time"] = moment().utc().format(Utils.DB_TIMESTAMP_FORMAT);
    data["from"] = this.chatUserType.PATIENT;
    data["contentType"] = "text";
    if (this.chatForm.get("chat_msg").value) {
      data["message"] = this.chatForm.get("chat_msg").value;
      this.realTimeService.send(data);
    }

    if (this.chatForm.get("chat_msg").value) {
      this.messages.push({
        id: this.appointment.pid,
        u_id: this.appointment.drid,
        body: this.chatForm.get("chat_msg").value,
        date: moment().toDate(),
      });
      this.chatForm.patchValue({ chat_msg: "" });
    }
    setTimeout(() => {
      this.chatForm.patchValue({ chat_msg: "" });
      this.chatForm.get("chat_msg").updateValueAndValidity();
    }, 100);
  }

  updateRoomId() {
    let data = { room_id: this.room_id };
    this.service
      .fetchRoomIDPhy(data, `u_id=${localStorage.getItem("uid")}`)
      .subscribe((res) => {
        this.room_id = res.room_id;
        this.subscribeToChatMessage();
      });
  }
  notifyCall(type) {
    let data = { uid: this.appointment.pid };
    if (type === Utils.APPOINTMENT_TYPE.AUDIO) {
      data["message"] = Utils.ENABLE_CALL.AUDIO;
    } else {
      data["message"] = Utils.ENABLE_CALL.VIDEO;
    }
    this.realTimeService.send(data);
  }

  joinCallRoom() {
    this.isMinimize = false;
    this.modalRef.close();
    this.showOnlineJoinCall = true;
    // this.onlineJoinCallRef = this.modal.open(this.onlineJoinCall, { size: 'lg', centered: true, backdrop: 'static' });
    setTimeout(() => (this.focus = false), 100);
  }

  getPhysicianDetails() {
    this.service.getPhysicianById(localStorage.getItem("drid")).subscribe(
      (result) => {
        this.physicianDetail = result;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  startChat() {
    this.chatStarted = true;
  }

  checkMsgType(body) {
    if (body) {
      if (typeof body === "string") {
        return typeof body;
      } else {
        return body["contentType"].substring(
          0,
          body["contentType"].indexOf("/")
        );
      }
    }
  }

  getChatHistory() {
    let data = {};
    data["u_id"] = this.appointment.pid;
    data["aptid"] = this.appointment.aptid;
    data["room_id"] = this.room_id;
    data["action"] = this.messageAction.SENDMESSAGE;
    data["type"] = this.messageAction.GETMESSAGES;
    this.realTimeService.send(data);
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  downloadDocument(doc) {
    Utils.downloadFile(doc);
  }

  closeModal() {
    this.modal.dismissAll();
  }

  closeJoinChatModal() {
    this.joinChatmodalRef.close();
  }

  closePopUp() {
    this.showOnlineJoinCall = false;
    this.modalRef.close();
  }
  ngOnDestry() {
    localStorage.clear();
    this.realTimeService.disconnect();
    if (this.isOpenSubscribe) {
      this.isOpenSubscribe.unsubscribe();
    }
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.isOpenSub) {
      this.isOpenSub.unsubscribe();
    }
  }
}
